/* Zion Forever Project | Conservation page behaviour.
   Runs once per page regardless of how many sections load it. Every hook is
   opt-in via data attributes, so a section that does not need behaviour costs
   nothing. Re-runs safely after theme editor section reloads. */
(function () {
  if (window.__zfpConsInit) { return; }
  window.__zfpConsInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(scope) {
    var root = scope || document;

    root.querySelectorAll('.zfp-cons__step-toggle').forEach(function (btn) {
      if (btn.dataset.bound) { return; }
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        var step = btn.closest('.zfp-cons__step');
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        step.classList.toggle('is-open', !open);
      });
    });

    var reveals = root.querySelectorAll('[data-reveal]:not([data-seen])');
    if (!('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var revealIO = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); revealIO.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    reveals.forEach(function (el) {
      el.dataset.seen = '1';
      var host = el.closest('.zfp-cons');
      if (reduce || !host || host.dataset.motion !== 'true') { el.classList.add('is-in'); }
      else { revealIO.observe(el); }
    });

    var counters = root.querySelectorAll('[data-count]:not([data-seen])');
    if (counters.length && !reduce) {
      var countIO = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) { return; }
          countIO.unobserve(e.target);
          var el = e.target;
          var parts = String(el.dataset.count).match(/^(\D*)([\d,]+)(.*)$/);
          if (!parts) { return; }
          var target = parseInt(parts[2].replace(/,/g, ''), 10);
          if (!isFinite(target)) { return; }
          var grouped = parts[2].indexOf(',') > -1;
          var start = null;
          function frame(ts) {
            if (start === null) { start = ts; }
            var p = Math.min((ts - start) / 1100, 1);
            var val = Math.round(target * (1 - Math.pow(1 - p, 3)));
            el.textContent = parts[1] + (grouped ? val.toLocaleString() : val) + parts[3];
            if (p < 1) { requestAnimationFrame(frame); }
          }
          el.textContent = parts[1] + '0' + parts[3];
          requestAnimationFrame(frame);
        });
      }, { threshold: 0.4 });
      counters.forEach(function (el) { el.dataset.seen = '1'; countIO.observe(el); });
    }

    var links = document.querySelectorAll('.zfp-cons__nav a');
    if (links.length && 'IntersectionObserver' in window && !document.__zfpNav) {
      document.__zfpNav = true;
      var map = {};
      links.forEach(function (a) {
        var id = (a.getAttribute('href') || '').replace('#', '');
        var t = id && document.getElementById(id);
        if (t) { map[id] = a; }
      });
      var navIO = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) { return; }
          links.forEach(function (a) { a.classList.remove('is-current'); });
          if (map[e.target.id]) { map[e.target.id].classList.add('is-current'); }
        });
      }, { rootMargin: '-45% 0px -50% 0px' });
      Object.keys(map).forEach(function (id) { navIO.observe(document.getElementById(id)); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else { init(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
